module.exports = __webpack_public_path__ + "static/media/17fc3bb4-6108-46a4-8ad7-59fd4abfd2fa_1.f31036f6cb61a21304052fb3016f0d54.440f0372.jpeg";